import { getRandomElement } from './utils';
import { bgColors } from './constants';

window.store = {
    debug: process.env.NODE_ENV === 'development',
    isMobile: false,
    state: {
      //post_id: cb_script_vars.postID
      post_uri: cb_script_vars.postURI,
      article_item: {
        title: '',
        content: '',
        date: '',
        excerpt : '',
      },
      slider_post_uri: cb_script_vars.postURI,
      slider_article_item: {
        title: '',
        content: '',
        date: '',
        excerpt : '',
      },
      posts: {
        nodes: [],
      },
      posts_next_page: null,
      posts_search_text: '',
      posts_search_active: false,
      //posts_cats: [{taxonomy: "POSTAUTHOR", terms: "18"}, {taxonomy: "POSTCOLLABORATOR", terms:"15"}],
      posts_cats: [],
      /*posts_tags: {
        tag_id: "11",
        tag_title: "glitch",
      },*/
      posts_tags: false,
      firstCallRouter: true,
      firstCallSlider: true,
      currentBgColor: false,
      filtered: false,
    },
  
    setPostURIAction (newValue) {
      if (this.debug) console.log('setPostURIAction triggered with', newValue)
      this.state.post_uri = newValue;
    },
  
    setSliderPostURIAction (newValue) {
      if (this.debug) console.log('setSliderPostURIAction triggered with', newValue)
      this.state.slider_post_uri = newValue;
    },
  
    setSearchText (newValue) {
      if (this.debug) console.log('setSearchText triggered with', newValue)
      this.state.posts_search_text = newValue;
    },
  
    setSearchActive (newValue) {
      if (this.debug) console.log('setSearchActive triggered with', newValue)
      this.state.posts_search_active = newValue;
      let newBgColor = getRandomElement(bgColors, this.state.currentBgColor);
      document.documentElement.style.setProperty("--bg-color", newBgColor);
      this.setCurrentBgColor(newBgColor);
      //this.state.posts_cats = [];
      //this.state.posts_tags = false;
    },
  
    setTag (newValue){
      if (this.debug) console.log('setTag triggered with', newValue)
      if(this.state.posts_tags?.tag_id == newValue.tag_id){
        this.state.posts_tags = false;  
      } else {
        this.state.posts_tags = newValue;
      }
      this.state.posts_cats = [];
      this.state.posts_search_text = "";
      this.state.posts_search_active = false;

      if(window.store.isMobile){
        document.getElementById('menu__wrapper').classList.remove('active');
        document.getElementById('main-right-container').classList.add('hide');      
      }

      window.scrollTo(0,0);
      document.getElementById('main-left-container').scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      let newBgColor = getRandomElement(bgColors, this.state.currentBgColor);
      document.documentElement.style.setProperty("--bg-color", newBgColor);
      this.setCurrentBgColor(newBgColor);
    },
  
    setCat (newCatId, newCatType, ){
      if (this.debug) console.log('setCat triggered with:' + newCatId + ' - ' + newCatType)
      if(!newCatId || !newCatType){
        this.state.posts_cats = [];      
      } else {
        this.state.posts_tags = false;
        /*this.state.posts_search_text = "";
        this.state.posts_search_active = false;*/
        newCatType = newCatType.toUpperCase();

        

        //this applies an AND filter kind of behaviour
        //deactivated 3rd of may 2022
        /*let currentElements = [...this.state.posts_cats];
        let newElement = {taxonomy: newCatType, terms: newCatId};
        if(_.some(currentElements,  newElement)){
          this.state.posts_cats = _.reject(currentElements, newElement);
        } else {
          currentElements.push(newElement);
          this.state.posts_cats = currentElements;
        }*/

        let currentElements = [...this.state.posts_cats];
        let newElement = {taxonomy: newCatType, terms: newCatId};
        if(_.some(currentElements,  newElement)){
          currentElements = []
          this.state.posts_cats = currentElements;
        } else {
          currentElements = []
          currentElements.push(newElement);
          this.state.posts_cats = currentElements;
        }

        //document.getElementById('menu__wrapper').classList.remove('active');
        //document.getElementById('main-right-container').classList.add('hide');
        window.scrollTo(0,0);
        document.getElementById('main-left-container').scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        let newBgColor = getRandomElement(bgColors, this.state.currentBgColor);
        document.documentElement.style.setProperty("--bg-color", newBgColor);
        this.setCurrentBgColor(newBgColor);
      }
      if(window.store.isMobile){
        document.getElementById('menu__wrapper').classList.remove('active');
        document.getElementById('main-right-container').classList.add('hide');      
      }
    },

    setCurrentBgColor (newColor) {
      this.state.currentBgColor = newColor;
    },
    
    setFirstCallRouter (newValue) {
      this.state.firstCallRouter = newValue;
    },
    
    setFirstCallSlider (newValue) {
      this.state.firstCallSlider = newValue;
    }    
}